module.exports = __webpack_public_path__ + "static/media/Add-User-Group.bcdf60a4.jpg";